
/* Product landings (Oct 7): ads, the Meta catalog, Google Shopping and emails link to /products/<handle>. Rings, oils,
   kits and the duo open their own page, but every bundle landed on the generic bundles grid, and lotions, cases, bays,
   diffusers and the mystery box on a collection or the products grid (40 of 96 catalog handles). If the router left a
   product landing on one of those lists, this opens a product page for the exact product instead: title, photo,
   description and price from Shopify (/products/<handle>.js), and one option per variant the cart can resolve
   (reverse of __VMAP.misc / __VMAP.lotion), added through quickAdd like every other add button. */
(function(){
  var LISTS={bundles:1,collection:1,products:1,oils:1};
  function names(){
    var V=window.__VMAP||{},r={};
    Object.keys(V.misc||{}).forEach(function(k){var id=V.misc[k];if(!r[id]||(k.indexOf('·')>-1&&r[id].indexOf('·')<0))r[id]=k});
    Object.keys(V.lotion||{}).forEach(function(k){if(!r[V.lotion[k]])r[V.lotion[k]]=k+' lotion'});
    Object.keys(V.oil||{}).forEach(function(k){if(!r[V.oil[k]])r[V.oil[k]]=k+' oil 5 mL'});
    Object.keys(V.ring||{}).forEach(function(k){var o=V.ring[k];Object.keys(o).forEach(function(f){if(!r[o[f]])r[o[f]]=k+' ring '+f})});
    return r;
  }
  function text(html){var d=document.createElement('div');d.innerHTML=html||'';var t=(d.textContent||'').replace(/\s+/g,' ').trim();
    if(t.length>420){t=t.slice(0,420);t=t.slice(0,t.lastIndexOf('. ')+1)||t+'…'}return t}
  function boot(){
    /* alternate product templates don't set __esLand, so read the handle off the URL */
    var path=location.pathname,m=path.match(/^\/products\/([^\/?#]+)/),land=window.__esLand||{};
    var h=(land.k==='product'&&land.h)||(m&&decodeURIComponent(m[1]));
    if(!h||!LISTS[window.current])return;
    if(h==='pick-your-mix-5-pack'){go('bundles');return}   /* build-your-own retired Oct 14: land on bundles */
    fetch('/products/'+encodeURIComponent(h)+'.js').then(function(r){return r.ok?r.json():null}).then(function(p){
      if(!p||!LISTS[window.current])return;   /* shopper already moved on */
      var R=names(),opts=[];
      (p.variants||[]).forEach(function(v){
        var n=R[v.id];if(!n||v.available===false)return;
        var pr=v.price/100;
        var l=(v.title&&v.title!=='Default Title')?v.title.toLowerCase():p.title.toLowerCase();
        opts.push({l:l+' · $'+pr.toFixed(2),n:n,p:pr});
      });
      if(!opts.length)return;               /* nothing addable: keep the list view */
      var im=document.createElement('img');im.src=(p.featured_image||'').replace(/^\/\//,'https://');
      var lede=(p.title||'').split(/ [-–—:] /).slice(1).join(' · ').toLowerCase();
      openGearPdp({t:p.title.split(/ [-–—:] /)[0].toLowerCase(),lede:lede,copy:text(p.description),imgEl:im,opts:opts});
      try{history.replaceState({es:{v:'lg',t:land.t||p.title}},'',path)}catch(e){}
      document.title='Essence · '+p.title;
    }).catch(function(){});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();
